module.exports = "/static/assets/366547fb2c98d87c8e41862fec4885b0.gif";